import { createTRPCClient, httpBatchLink } from '@trpc/client'
import type { AppRouter } from '../../../server/trpc/router'

/**
 * tRPC client for frontend
 * Provides type-safe API calls to the backend
 *
 * @example
 * ```typescript
 * import { trpc } from '@/shared/lib/trpc';
 *
 * // Call a tRPC procedure
 * const result = await trpc.newsletter.subscribe.mutate({
 *   email: 'user@example.com'
 * });
 * ```
 */
export const trpc = createTRPCClient<AppRouter>({
  links: [
    httpBatchLink({
      url: '/api/trpc',
      // Optional: Add headers for authentication, etc.
      headers() {
        return {
          // Add any custom headers here
        }
      },
    }),
  ],
})

// Export type for use in components
export type { AppRouter }
